<template>
  <CSidebar
    class="sidebar-custom"
    :minimize="minimize"
    unfoldable
    :show="show"
    @update:show="(value) => $store.commit('gui/set', ['sidebarShow', value])">

    <CSidebarBrand to="/">
      <div class="sidebar-logo"></div>
    </CSidebarBrand>

    <CRenderFunction flat :contentToRender="$options.nav"/>

    <CSidebarMinimizer
      class="c-d-md-down-none"
      @click.native="$store.commit('gui/toggle', 'sidebarMinimize')"
    />
  </CSidebar>
</template>

<script>
import nav from '../router/coreui_nav';

export default {
  name: 'TheSidebar',
  nav,
  computed: {
    show () {
      return this.$store.state.gui.sidebarShow;
    },
    minimize () {
      return this.$store.state.gui.sidebarMinimize;
    }
  }
}
</script>

<style>
  .sidebar-logo {
    width: 100%;
    height: 100%;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    background-image: url('../assets/images/brand_ob/logo.png');
  }

  /*
  .sidebar-custom {
    width: 220px;
  }
  */

</style>
